import { IServerSideGetRowsRequest } from 'ag-grid-community';

export interface Search {
  search: string;
  id: string;
  id2: string;
  includeAll: boolean;
  serverSideSearch: IServerSideGetRowsRequest;

  layout?: string;
}
